import {Administrator} from "../services/models/administrator";

export default function isAdministrator(obj: any): obj is Administrator {
    return obj && obj.role === undefined
}